import _ from "lodash"

import en from "./en"
import fr from "./fr"

export default {
  fr: _.merge({}, fr, { common: { lang: "fr" } }),
  en: _.merge({}, en, { common: { lang: "en" } }),
}
